var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPtlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "45.000000pt",
    height: "45.000000pt",
    viewBox: "0 0 200.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "#E83283",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M884 1879 c-3 -6 -2 -15 4 -21 13 -13 32 -2 32 18 0 16 -26 19 -36 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964 1879 c-3 -6 -2 -15 4 -21 13 -13 32 -2 32 18 0 16 -26 19 -36 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805 1871 c-8 -15 3 -31 21 -31 9 0 14 7 12 17 -4 20 -24 28 -33 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040 1865 c0 -8 9 -15 20 -15 11 0 20 7 20 15 0 8 -9 15 -20 15 -11 0 -20 -7 -20 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 1850 c0 -19 20 -27 33 -13 8 7 -11 33 -24 33 -5 0 -9 -9 -9 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117 1863 c-4 -3 -2 -12 4 -20 9 -10 15 -10 25 -2 8 6 14 15 14 20 0 10 -34 12 -43 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197 1854 c-14 -14 -7 -35 11 -32 9 2 17 10 17 17 0 16 -18 25 -28 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661 1836 c-12 -14 -5 -26 16 -26 15 0 18 26 4 34 -5 3 -14 0 -20 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267 1823 c-13 -12 -7 -33 8 -33 8 0 15 9 15 20 0 20 -11 26 -23 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 1796 c0 -10 9 -16 21 -16 24 0 21 23 -4 28 -10 2 -17 -3 -17 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326 1781 c-3 -5 0 -14 8 -20 10 -8 16 -8 25 2 6 8 8 17 4 20 -9 10 -31 9 -37 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522 1763 c2 -10 10 -18 18 -18 22 0 18 29 -3 33 -14 3 -18 -1 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396 1752 c-2 -4 -1 -14 4 -22 7 -11 12 -12 21 -3 6 6 8 16 5 22 -8 13 -23 14 -30 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 1729 c-3 -6 -1 -16 5 -22 9 -9 14 -8 21 3 9 15 4 30 -10 30 -5 0 -12 -5 -16 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462 1694 c4 -21 22 -23 26 -1 2 10 -3 17 -13 17 -10 0 -15 -6 -13 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 1676 c0 -8 4 -17 9 -20 11 -7 33 18 24 27 -12 12 -33 7 -33 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523 1655 c-7 -20 2 -29 21 -22 9 4 13 13 10 22 -8 19 -23 19 -31 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 1626 c0 -8 4 -17 9 -20 11 -7 33 18 24 27 -12 12 -33 7 -33 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1570 1596 c0 -15 24 -28 34 -19 13 14 5 33 -14 33 -11 0 -20 -6 -20 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 1571 c-3 -5 0 -14 8 -20 10 -8 16 -8 25 2 6 8 8 17 4 20 -9 10 -31 9 -37 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615 1540 c-8 -12 20 -24 35 -15 6 3 8 11 5 16 -8 12 -32 12 -40 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 1510 c0 -19 20 -27 33 -13 8 7 -11 33 -24 33 -5 0 -9 -9 -9 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657 1484 c-9 -10 2 -24 19 -24 8 0 14 7 14 15 0 15 -21 21 -33 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 1446 c0 -21 21 -31 30 -15 5 7 6 17 4 21 -9 14 -34 9 -34 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1694 1419 c-10 -17 13 -36 27 -22 12 12 4 33 -11 33 -5 0 -12 -5 -16 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 1391 c-8 -15 3 -31 21 -31 9 0 14 7 12 17 -4 20 -24 28 -33 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989 1373 c-6 -6 -9 -31 -7 -55 l3 -43 68 -3 67 -3 0 -284 0 -285 55 0 55 0 1 133 c1 72 2 201 2 286 l2 153 63 2 c73 2 88 16 78 72 l-7 34 -67 1 c-276 4 -304 3 -313 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 1059 c-1 -178 1 -331 4 -341 6 -19 46 -24 92 -12 22 6 23 10 22 108 -2 184 -8 166 53 166 62 0 131 31 161 72 15 21 21 49 24 112 4 73 1 91 -18 131 -33 68 -61 79 -211 83 l-125 4 -2 -323z m236 178 c13 -27 9 -100 -7 -126 -5 -7 -30 -13 -57 -14 l-49 -2 -3 88 -3 88 53 -3 c46 -3 54 -6 66 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1716 1351 c-3 -5 0 -14 8 -20 10 -8 16 -8 25 2 6 8 8 17 4 20 -9 10 -31 9 -37 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 1319 c-10 -17 13 -36 27 -22 12 12 4 33 -11 33 -5 0 -12 -5 -16 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742 1273 c2 -10 10 -18 18 -18 22 0 18 29 -3 33 -14 3 -18 -1 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 1253 c-7 -2 -13 -11 -13 -20 0 -20 34 -12 38 10 3 17 -3 20 -25 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767 1214 c-14 -14 -7 -35 11 -32 9 2 17 10 17 17 0 16 -18 25 -28 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 1183 c-18 -6 -16 -33 1 -33 19 0 31 19 20 30 -5 4 -15 5 -21 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777 1144 c-14 -14 -7 -35 11 -32 9 2 17 10 17 17 0 16 -18 25 -28 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 1106 c-9 -24 12 -44 28 -28 10 10 8 16 -5 29 -15 15 -17 15 -23 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775 1071 c-8 -15 3 -31 21 -31 9 0 14 7 12 17 -4 20 -24 28 -33 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 1020 c0 -11 4 -20 9 -20 13 0 32 26 24 33 -13 14 -33 6 -33 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777 1004 c-14 -14 -7 -35 11 -32 9 2 17 10 17 17 0 16 -18 25 -28 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 950 c0 -15 5 -20 18 -18 9 2 17 10 17 18 0 8 -8 16 -17 18 -13 2 -18 -3 -18 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767 934 c-14 -14 -7 -35 11 -32 9 2 17 10 17 17 0 16 -18 25 -28 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 893 c-8 -7 11 -33 24 -33 5 0 9 9 9 20 0 19 -20 27 -33 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1746 855 c-3 -9 1 -18 10 -22 19 -7 28 2 21 22 -8 19 -23 19 -31 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 822 c-8 -13 11 -35 23 -28 16 10 14 36 -3 36 -8 0 -17 -4 -20 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1731 786 c-12 -14 -5 -26 16 -26 15 0 18 26 4 34 -5 3 -14 0 -20 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 760 c-4 -6 -3 -14 0 -20 9 -15 35 -12 35 4 0 17 -27 29 -35 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1700 706 c0 -8 4 -17 9 -20 11 -7 33 18 24 27 -12 12 -33 7 -33 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 681 c-7 -11 18 -33 27 -24 4 3 7 12 7 20 0 15 -26 18 -34 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674 649 c-10 -17 13 -36 27 -22 12 12 4 33 -11 33 -5 0 -12 -5 -16 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 621 c-8 -15 3 -31 21 -31 9 0 14 7 12 17 -4 20 -24 28 -33 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1637 594 c-14 -14 -7 -35 11 -32 9 2 17 10 17 17 0 16 -18 25 -28 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 553 c4 -21 33 -25 33 -3 0 8 -8 16 -18 18 -14 3 -18 -1 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587 526 c-7 -16 1 -26 20 -26 7 0 13 9 13 20 0 23 -25 27 -33 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 495 c0 -10 7 -15 18 -13 21 4 19 22 -2 26 -10 2 -16 -3 -16 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542 463 c2 -10 10 -18 18 -18 22 0 18 29 -3 33 -14 3 -18 -1 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364 449 c-10 -17 13 -36 27 -22 12 12 4 33 -11 33 -5 0 -12 -5 -16 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484 419 c-9 -15 11 -33 30 -26 9 4 13 13 10 22 -7 17 -30 20 -40 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 404 c-14 -14 -7 -35 11 -32 9 2 17 10 17 17 0 16 -18 25 -28 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424 379 c-10 -17 13 -36 27 -22 12 12 4 33 -11 33 -5 0 -12 -5 -16 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493 354 c-8 -20 8 -36 26 -25 15 10 8 41 -9 41 -6 0 -13 -7 -17 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357 334 c-9 -10 2 -24 19 -24 8 0 14 7 14 15 0 15 -21 21 -33 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567 324 c-14 -14 -7 -35 11 -32 9 2 17 10 17 17 0 16 -18 25 -28 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 296 c0 -8 4 -17 9 -20 11 -7 33 18 24 27 -12 12 -33 7 -33 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631 286 c-12 -14 -5 -26 16 -26 15 0 18 26 4 34 -5 3 -14 0 -20 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220 266 c0 -21 20 -30 33 -17 9 9 8 14 -3 21 -21 14 -30 12 -30 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707 263 c-13 -12 -7 -33 8 -33 8 0 15 9 15 20 0 20 -11 26 -23 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157 254 c-14 -14 -7 -35 11 -32 9 2 17 10 17 17 0 16 -18 25 -28 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777 243 c-4 -3 -7 -12 -7 -20 0 -15 26 -18 34 -4 7 11 -18 33 -27 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844 229 c-8 -14 11 -33 25 -25 6 4 11 14 11 22 0 16 -26 19 -36 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007 234 c-14 -14 -7 -35 11 -32 9 2 17 10 17 17 0 16 -18 25 -28 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076 231 c-7 -11 18 -33 27 -24 4 3 7 12 7 20 0 15 -26 18 -34 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931 220 c-16 -9 -6 -30 15 -30 15 0 20 25 6 34 -4 2 -14 1 -21 -4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtlogo);
export default __webpack_public_path__ + "static/media/ptlogo.fb58ef41d9631f378d82896669e1b19f.svg";
export { ForwardRef as ReactComponent };